import type { ReactNode } from "react";

import { HaNSliderCard } from "./HaNSliderCard";

// A card that opens its result's details
export const HaNSliderCardButton = ({ onClick, children }: { onClick: () => void; children: ReactNode }) => {
  return (
    <HaNSliderCard className="p-0">
      <button
        type="button"
        className="flex w-full items-center rounded-lg border-2 border-transparent p-2 text-left focus-visible:border-mapiq-black-800* focus-visible:outline-none"
        onClick={onClick}>
        {children}
      </button>
    </HaNSliderCard>
  );
};
